module.exports = __webpack_public_path__ + "assets/img/imgSet.f9ca99b8.png";